import { createSelector } from 'reselect';

export const dealerLocaleSelector = state => state.dealerLocale;

export const getLocaleCode = createSelector(
  dealerLocaleSelector,
  dealerLocale => {
    if (dealerLocale) {
      return dealerLocale.locale;
    } else {
      return '';
    }
  }
);

export const getLanguageCode = createSelector(
  dealerLocaleSelector,
  dealerLocale => {
    if (dealerLocale) {
      return dealerLocale.languageCode;
    } else {
      return '';
    }
  }
);

export const getCountryCode = createSelector(
  dealerLocaleSelector,
  dealerLocale => {
    if (dealerLocale) {
      return dealerLocale.countryCode;
    } else {
      return '';
    }
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/dealerLocale/selectors.js